import React, { useState } from 'react'

import AnimatedLogo from '~/components/AnimatedLogo'
import { Breakpoint } from '@material-ui/core/styles/createBreakpoints'
import { Institution } from '~/types/institution'
import Links from '~/components/Navigation/Links'
import { useScrollPosition } from '@n8tb1t/use-scroll-position'
import { withWidth } from '@material-ui/core'

type ViewProps = {
    institutions: Institution[]
    location: Location
    isExpandable: boolean
    width: Breakpoint
}

export default withWidth()(({ institutions, location, isExpandable, width }: ViewProps) => {
    const [isExpanded, setIsExpanded] = useState(isExpandable ? false : true)
    const [isScrolled, setIsScrolled] = useState(false)
    const [isScrollingDown, setIsScrollingDown] = useState(true)
    const [scrollPosition, setScrollPosition] = useState(0)
    const isMobile = ['xs', 'sm'].includes(width)
    const scrollBreakpoint = width === 'xs' ? -200 : width === 'sm' ? -450 : -1650
    const isFeed = location.pathname.replace(new RegExp('/', 'g'), '') === 'feed'

    useScrollPosition(
        ({ prevPos, currPos }) => {
            if (isExpandable && isExpanded && currPos.y < prevPos.y) {
                setIsExpanded(false)
            }

            if (!isScrolled && currPos.y < scrollBreakpoint) {
                setIsScrolled(true)
            } else if (isScrolled && currPos.y >= scrollBreakpoint) {
                setIsScrolled(false)
            }
            setIsScrollingDown(currPos.y < prevPos.y)

            setScrollPosition(currPos.y)
        },
        [setIsExpanded, setIsScrolled, isScrolled, setScrollPosition],
        undefined,
        false,
        50
    )

    return (
        <>
            <Links
                location={location}
                isExpandable={isExpandable}
                isExpanded={isExpanded}
                setIsExpanded={setIsExpanded}
                isScrolled={isScrolled}
                institutions={institutions}
            />

            {isFeed && (
                <AnimatedLogo
                    isClockwise={isScrollingDown}
                    isMobile={isMobile}
                    scrollPosition={scrollPosition}
                />
            )}
        </>
    )
})
